import { type ClassValue, clsx } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

/**
 * tailwind-merge only knows Tailwind's default font sizes. Without this, a
 * custom size like `text-submenu` or `text-page-title` is mistaken for a text
 * COLOR and silently dropped whenever the same element also has a color class
 * (`text-foreground`, `text-sidebar-muted` …). Keep in sync with `fontSize` in
 * tailwind.config.js.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "page-title", "section-title", "card-title", "menu", "submenu", "content", "meta",
            "metric", "title", "label", "caption", "overline", "code", "data",
            "h1", "h2", "h3", "h4", "h5", "h6",
            "display-xl", "display-lg", "display-md",
            "body-xl", "body-lg", "body-md", "body-sm", "body-xs",
          ],
        },
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
